import signupImg from "../assets/Images/SignupIcon.webp"
import Template from "../components/core/Auth/Template"

function Signup() {
  return (
   <div className="bg-blue-150">
     <Template
      title="Join the millions learning to code with CourseCatalyst for free"
      description1="Build skills for today, tomorrow, and beyond."
      description2="Education to future-proof your career."
      image={signupImg}
      formType="signup"
    />
   </div>
  )
}

export default Signup
